import React, { Component, lazy, Suspense, useRef, useState } from 'react';
import { withRouter, Redirect, Route, Switch, useParams } from 'react-router';
import IframeResizer from 'iframe-resizer-react';
import parse from 'html-react-parser';
import axios from 'axios';
import PageContainer from '../@jumbo/components/PageComponents/layouts/PageContainer';

const MyExternals = ({ match }) => {
  const requestedUrl = match.url; //.replace(/\/$/, '');
  return (
    <Switch>
      <Route path="/admin/:id" children={props => <Child {...props} />} />
    </Switch>
  );
};

class Child extends Component {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  constructor(props) {
    super(props);
    this.state = { myid: '', code: '' };
  }
  loadurl(id) {
    if (id == '') return;
    const token = localStorage.getItem('token');
    var url = 'https://secure.webbookingpro.com/index2.php?admin=' + id;
    const senddata = {
      Action: 'Redirect',
      token: token,
      URL: url,
    };
    var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    axios
      .post(pmsUrl, senddata, {
        withCredentials: true,
      })
      .then(res => {
        const mycode = '<iframe style="border:none;"width="100%" height="100%" src="' + url + '"></iframe>';
        this.setState({ code: mycode });
        //window.location = url;
      });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      const id = this.props.match.params.id;
      this.loadurl(id);
    }
  }
  componentDidMount() {
    const id = this.props.match.params.id;
    console.log(this.props.match.params);
    this.loadurl(id);
  }

  render() {
    return <>{parse(this.state.code)}</>;
  }
}

export default withRouter(MyExternals);
